module.exports = __webpack_public_path__ + "img/20210610-IMG_0546.42212471.jpg";